<script lang="ts">
  export let extraClasses: string = "";
  export let specifiedId: string = "";

</script>

<div class="fizz-styles {extraClasses}" id={specifiedId}>
  <slot />
</div>
